import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import cfg from "@/cfg";
import user from './modules/user'
import addresses from './modules/addresses'
import signupintent from './modules/signupintent'
import notifications from './modules/notifications'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'accountsStore',
  storage: window.sessionStorage,
})

const getDefaultState = () => {
  return {
    urlSearchParams: null,
    continueHref: null,
    Cfg: cfg
  }
}

// initial state
const state = getDefaultState()

export const getters = {
  urlSearchParams: state => state.urlSearchParams,
  continueHref: state => state.continueHref,
  GetCfg: state => state.Cfg
}

export const actions = {
  ResetState({commit}) {
    commit('RESET_MAIN_STATE')
    commit('RESET_ADDRESSES_STATE')
    commit('RESET_SIGNUPINTENT_STATE')
    commit('RESET_USER_STATE')
  },
  InitStore({commit}){
    console.log("init store")
    const urlSearchParams = new URLSearchParams(window.location.search);
    state.urlSearchParams = urlSearchParams
    
    // check if continue is one of our allowed hosts before saving it
    // to the store.
    let host = null
    let url = null

    try{
      url = new URL(urlSearchParams.get("continue"));
      host = url.host
      console.log(url)
      console.log(host)
      if(host && cfg.AFTER_LOGIN_CONTINUE_ALLOWED_HOSTS.indexOf(host) > -1){
        commit('SET_CONTINUE', url.href)
      }
    }catch(error){
      commit('SET_CONTINUE', null)
    }
  },
}

export const mutations = {
  SET_CONTINUE(state, href) {
    state.continueHref = href
  },
  RESET_MAIN_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

export default new Vuex.Store({
  actions,
  state,
  mutations,
  getters,
  modules:{
    user,
    addresses,
    signupintent,
    notifications,
  },
  plugins: [vuexLocalStorage.plugin],
})
